// project-token.ts
import { InjectionToken } from '@angular/core';

export enum ProjectAuthNames {
  CLIENT = 'client',
  MEMBER = 'member',
  ADMIN = 'admin'
}

export const PROJECT_NAME = new InjectionToken<string>('ProjectName');
